<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('My profile') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">
      <form id="user-details-form" class="shurt-conatiner" v-on:submit.prevent="saveProfile(user)">
        <div class="form-group">
          <label>{{ $t('Name') }}</label>
          <input type="text" class="form-control" v-model="user.name">
          <ValidateMessage :error="validateErrors.name" />
        </div>
        <div class="form-group">
          <label>
            {{ $t('Email') }}
            (<router-link to="/config/change-email">Alterar</router-link>)
          </label>
          <input type="text" class="form-control" v-model="user.email" disabled="disabled">
        </div>
        <div class="form-group">
          <label>Timezone</label>
          <select-timezone v-model="user.timezone"></select-timezone>
          <ValidateMessage :error="validateErrors.timezone" />
          <div
            v-if="browserTimezone && browserTimezone !== user.timezone"
            class="text-danger">
            <span v-html="$t('correct_timezone', {browserTimezone: browserTimezone})"></span> - <a href="javascript:void(0)" @click="user.timezone = browserTimezone">{{ $t('Update') }}</a>
            </div>
        </div>
        <div class="form-group">
          <label>{{ $t('Language') }}</label>
          <select-locale v-model="user.locale"></select-locale>
          <ValidateMessage :error="validateErrors.locale" />
        </div>
        <div class="form-group">
          <label>{{ $t('Photo') }}</label>
          <div class="mb-3">
            <Avatar
              :src="imgSrc"
              :name="user.name"
              size="100px"
              radius="50px"
              resize="100x100x1" />
          </div>
          <InputOnePhoto
            v-model="user.photo_media_id"
            @input="setFile" />
          <ValidateMessage :error="validateErrors.photo_media_id" />
        </div>
      </form>
    </div>

    <div class="vflex-row-0 vflex-footer p-3">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="user-details-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
      </div>
    </div>
    
  </div>

</template>

<script>
import moment from 'moment'
import config from '@/config'
import SelectTimezone from '@/components/Fields/SelectTimezone'
import SelectLocale from '@/components/Fields/SelectLocale'
import InputOnePhoto from '@/components/Fields/InputOnePhoto'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'ProfileDetails',
  components: {
    SelectTimezone,
    SelectLocale,
    InputOnePhoto,
    Avatar
  },
  data () {
    return {
      loading: false,
      user: this.$clone(this.$store.getters.getMe),
      validateErrors: false
    }
  },
  computed: {
    token () {
      return this.$store.getters.authToken
    },
    browserTimezone () {
      return moment.tz.guess()
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateMe', data)
      .then((result) => {
        this.$i18n.locale = this.user.locale
        this.loading = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    setFile
    */
    setFile (media) {
      this.user.photo_media_url = media ? media.url : null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileDetails.vue